<template>
  <div class="tw-w-full">
    <div
      v-if="loadingSwitchCandidates"
      class="position-absolute start-0 top-0 fill-height fill-width d-flex justify-center align-center loading-screen"
    >
      <v-progress-circular
        :size="72"
        :width="6"
        color="primary"
        indeterminate
        class="ma-auto"
      ></v-progress-circular>
    </div>

    <div v-if="!loading" ref="pile" class="fill-height fill-width">
      <CardV2
        v-for="(candidate, index) in candidates"
        v-bind:key="candidate._id"
        v-bind:ref="backwardIndex(index, candidates.length)"
        v-bind:candidate="candidate"
        v-bind:shouldRenderLSD="shouldRenderLSD"
        v-bind:projectId="projectId"
        v-bind:isInCalibration="isCalibration"
        v-bind:isInCalibrationNewProject="isInCalibrationNewProject"
        :currentUserRole="currentUserRole"
        :displayClipBoard="displayClipBoard"
        :projectData="projectData"
        :tab="isCalibration ? 'UNDER_REVIEW' : tab"
        :totalCandidates="totalCandidates"
        :candidateIndex="candidateIndex"
        :loading="loading"
        :pageIdx="pageIdx"
        :limit="limit"
        class="tw-hidden"
        :class="[
          {
            '!tw-block': candidate._id === currentCandidate._id,
          },
        ]"
        :iscurrentGolive="iscurrentGolive"
        :isShowIntro2="isShowIntro2"
        :introStep2="introStep"
        :showFakeCard="showFakeCard"
        :currentTab="currentTab"
        :isLoading="loading || loading2 || isLoadingCandidate"
        @approve="approveCandidate"
        @reject="rejectCandidate"
        @keep="keepCandidate"
        v-on:schedule="scheduleCandidate"
        v-on:acceptLSD="acceptLSD"
        v-on:rejectLSD="rejectLSD"
        v-on:prev="previousCandidate"
        v-on:next="nextCandidate"
        v-on:movecard="moveCard"
        v-on:visualMove="setCandidateStatus"
        @closeInfo="$emit('closeInfo')"
        @closeIntro="$emit('closeIntro')"
        @prevent-approve-need-calendar-sync="
          $emit('prevent-approve-need-calendar-sync')
        "
        @disabled-right-side="$emit('disabled-right-side', $event)"
        @next-candidate="onNextCandidate"
        @prev-candidate="onPrevCandidate"
        @expand-email="$emit('expand-email', $event)"
      />
    </div>
    <v-snackbar v-model="snackbar">{{ alertMessage }}</v-snackbar>
  </div>
</template>

<script>
import artboardIcon from '@/assets/img/Artboard.svg';
import CardV2 from '@/components/card/CardV2';
import { sleep } from '@/utils/';
import { nextTick } from 'vue';

export default {
  components: {
    CardV2,
  },

  props: {
    candidates: Array,
    projectId: String,
    tab: String,
    shouldRenderLSD: Boolean,
    currentUserRole: Number,
    loading: Boolean,
    loading2: Boolean,
    isCalibration: Boolean,
    currentCalibration: Boolean,
    isInCalibrationNewProject: Boolean,
    iscurrentGolive: Boolean,
    isShowIntro2: Boolean,
    introStep: [String, Number],
    showFakeCard: Boolean,
    displayClipBoard: Boolean,
    isLoadingCandidate: Boolean,
    projectData: {
      type: Object,
      default: () => {},
    },

    totalCandidates: Number,
    currentTab: [String, Boolean, Number],
    candidateIndex: Number,
    pageIdx: Number,
    limit: Number,
    currentCandidate: Object,
  },

  data() {
    return {
      showSnackbar: false,
      blockAction: false,
      loadingSwitchCandidates: false,
      height: 0,
      payload: {
        is_in_auto_swipe_calibration: false,
      },

      firstCandidate: true,
      alertMessage: '',
      snackbar: false,
    };
  },

  computed: {
    artboardIcon: () => artboardIcon,
    selectedProject() {
      return (
        this.$store.getters['projects/getProjectById'](this.projectId) || {}
      );
    },

    isPilot() {
      return (
        this.selectedProject.in_auto_swipe_mode || // TODO(jeremiah): delete this line after V2 migration
        this.selectedProject.type === '1' ||
        this.selectedProject.type === '3'
      );
    },

    isLoading() {
      return this.$store.getters['projects/candidates/getIsLoading'];
    },

    isV2() {
      return this.$store.getters['user/getIsUserV2'];
    },

    isNavigator() {
      return this.selectedProject.type === '2';
    },
  },

  watch: {
    loading() {
      this.showSnackbar = true;
    },

    candidates() {
      setTimeout(() => {
        this.setMinHeight();
      }, 1000);
    },

    tab() {
      setTimeout(() => {
        this.setMinHeight();
      }, 1000);
    },

    // TODO(jeremiah): delete this after v2 rollout
    isCalibration(v) {
      this.payload.is_in_auto_swipe_calibration = v;
    },

    // TODO(jeremiah): delete this after v2 rollout
    currentCalibration() {
      this.payload.is_in_auto_swipe_calibration = this.currentCalibration;
    },
  },

  // TODO(jeremiah): delete this after v2 rollout
  mounted() {
    this.payload.is_in_auto_swipe_calibration = this.isCalibration;
    setTimeout(() => {
      this.setMinHeight();
    }, 1000);
  },

  methods: {
    backwardIndex(index, length) {
      if (index === length - 1) {
        return 'front';
      }
      if (index === length - 2) {
        return 'front-1';
      }
      if (index === length - 3) {
        return 'front-2';
      }
      if (index === 0) {
        return 'last';
      }
      return 'behind';
    },

    moveCards(from, to) {
      if (this.$refs[from] && this.$refs[from].length > 0) {
        const el = this.$refs[from][0].$el;
        const re = new RegExp(from);
        // Special logic for IE9
        el.className = el.className ? el.className.replace(re, to) : '';
      }
      this.firstCandidate = false;
    },

    previousCandidate() {
      if (this.blockAction) {
        return;
      }
      if (this.candidates.length === 1) {
        return;
      }

      // First block all future action click button.
      this.blockAction = true;

      // Start a dedicated animation.
      const { pile } = this.$refs;
      const { firstChild } = pile;
      firstChild.classList.add('move-to-front');
      if (this.candidates.length > 1) {
        this.moveCards('front', 'front-1');
      }
      if (this.candidates.length > 2) {
        this.moveCards('front-1', 'front-2');
      }

      // After animation, kick off the re-rendering.
      setTimeout(() => {
        this.$store.commit('projects/candidates/MOVE_PREV', {
          projectId: this.projectId,
          tab: this.tab,
        });

        // Unblock action button.
        this.blockAction = false;
      }, 500);
      this.firstCandidate = false;
    },

    nextCandidate() {
      if (this.blockAction) {
        return;
      }
      if (this.candidates.length === 1) {
        return;
      }
      this.firstCandidate = false;
      // First block all future action click button.
      this.blockAction = true;

      // Start a dedicated animation.
      const { pile } = this.$refs;
      const { lastChild } = pile;
      if (this.candidates.length === 2) {
        lastChild.classList.add('move-to-back-2');
        this.moveCards('front-1', 'front');
      } else {
        lastChild.classList.add('move-to-back-3');
        this.moveCards('front-1', 'front');
        this.moveCards('front-2', 'front-1');
      }

      // After animation, kick off the re-rendering.
      setTimeout(() => {
        this.$store.commit('projects/candidates/MOVE_NEXT', {
          projectId: this.projectId,
          tab: this.tab,
        });

        // Unblock action button.
        this.blockAction = false;
      }, 500);
    },

    acceptLSD() {
      console.log('user approved LSD');
      this.$store.commit('projects/REMOVE_LEFT_SWIPE_DIALOG', {
        projectId: this.projectId,
      });
      this.$store.dispatch('projects/reformQuery', {
        projectId: this.projectId,
      });
    },

    rejectLSD() {
      this.$store.commit('projects/REMOVE_LEFT_SWIPE_DIALOG', {
        projectId: this.projectId,
      });
    },

    // TODO(jeremiah): clean up after v2 rollout
    async approveCandidate({ candidateId }) {
      if (this.isV2) {
        this.approveCandidateV2(candidateId);
        return;
      }
      // Start the animation
      this.moveCards('front-1', 'front');
      this.moveCards('front-2', 'front-1');
      const tab = this.isCalibration ? 'UNDER_REVIEW' : this.tab;
      const res = await this.$store.dispatch(
        'projects/candidates/updateCandidateState',
        {
          projectId: this.projectId,
          tab,
          candidateId,
          newTab: 'APPROVED',
        }
      );
      if (res === false)
        this.openSnackbar('Swipe candidate failed - Please try again later.');
    },

    async approveCandidateV2(candidateId) {
      // Start the animation
      this.moveCards('front-1', 'front');
      this.moveCards('front-2', 'front-1');

      const tab = this.isCalibration ? 'UNDER_REVIEW' : this.tab;

      // Swipes don't happen for autopilot/self-serve except in calibration
      if (!this.isNavigator && !this.isCalibration) return;

      try {
        const remaining = await this.$store.dispatch(
          'projects/candidates/swipe',
          {
            projectId: this.projectId,
            tab,
            candidateId,
            approved: true,
            isCalibration: this.isCalibration,
          }
        );
        if (remaining === 0 && this.isCalibration) {
          this.startProgressBar(0);
          this.$emit('changecalibration', false);
          return;
        }
        if (remaining === false)
          this.openSnackbar('Swipe candidate failed - Please try again later.');
      } catch (err) {
        this.openSnackbar('Swipe candidate failed - Please try again later.');
      }
    },

    openSnackbar(e) {
      this.snackbar = true;
      this.alertMessage = e;
    },

    // TODO(jeremiah): clean up after v2 rollout
    async rejectCandidate({ candidateId, reasons, reason }) {
      if (this.isV2) {
        this.rejectCandidateV2(candidateId, reasons);
        return;
      }
      // Start the animation
      this.moveCards('front-1', 'front');
      this.moveCards('front-2', 'front-1');
      const tab = this.isCalibration ? 'UNDER_REVIEW' : this.tab;
      const res = await this.$store.dispatch(
        'projects/candidates/updateCandidateState',
        {
          projectId: this.projectId,
          tab,
          candidateId,
          newTab: 'REJECTED',
          payload: reason,
        }
      );
      if (res === false)
        this.openSnackbar('Swipe candidate failed - Please try again later.');
    },

    async rejectCandidateV2(candidateId, reasons) {
      // Start the animation
      this.moveCards('front-1', 'front');
      this.moveCards('front-2', 'front-1');

      const tab = this.isCalibration ? 'UNDER_REVIEW' : this.tab;
      if (this.isNavigator || this.isCalibration) {
        try {
          const remaining = await this.$store.dispatch(
            'projects/candidates/swipe',
            {
              projectId: this.projectId,
              tab,
              candidateId,
              approved: false,
              rejection_reasons: reasons,
              isCalibration: this.isCalibration,
            }
          );
          if (remaining === 0 && this.isCalibration) {
            this.$emit('changecalibration', false);
            this.startProgressBar(0);
            return;
          }
          if (remaining === false)
            this.openSnackbar(
              'Swipe candidate failed - Please try again later.'
            );
        } catch (err) {
          this.openSnackbar('Swipe candidate failed - Please try again later.');
        }

        return;
      }
      const candidate = this.$store.getters[
        'projects/candidates/listCandidates'
      ](this.projectId, this.tab).find((cand) => cand._id === candidateId);
      const res = await this.$store.dispatch(
        'projects/candidates/rejectCandidate',
        {
          project_id: this.projectId,
          tab: this.tab,
          candidate,
          rejection_reasons: reasons,
        }
      );
      if (res === false)
        this.openSnackbar('Swipe candidate failed - Please try again later.');
    },

    async keepCandidate({ additional_info_type, candidate }) {
      // Start the animation
      this.moveCards('front-1', 'front');
      this.moveCards('front-2', 'front-1');
      try {
        const response = await this.$store.dispatch(
          'projects/candidates/keepCandidateNeedAdditionalInfo',
          {
            project_id: this.projectId,
            tab: this.tab,
            candidate,
            additional_info_type,
          }
        );
        if (response === false) {
          this.openSnackbar('Swipe candidate failed - Please try again later.');
        } else {
          this.openSnackbar(
            "This candidate will reappear in your 'Interested' tab once they share the requested item with us."
          );
        }
      } catch (err) {
        this.openSnackbar('Swipe candidate failed - Please try again later.');
      }
    },

    scheduleCandidate() {
      this.setCandidateStatus();
    },

    async moveCard({ candidate, newTab, payload }) {
      this.setCandidateStatus();
      // TODO(jeremiah): clean this up after v2
      let res;
      if (this.isV2) {
        res = await this.$store.dispatch('projects/candidates/moveCandidate', {
          projectId: this.projectId,
          tab: this.tab.toUpperCase(),
          candidate,
          newTab: newTab.toUpperCase(),
        });
      } else {
        res = await this.$store.dispatch(
          'projects/candidates/updateCandidateState',
          {
            projectId: this.projectId,
            tab: this.tab,
            candidateId: candidate._id,
            newTab,
            payload,
          }
        );
      }
      this.firstCandidate = false;
      if (res === false)
        this.openSnackbar('Swipe candidate failed - Please try again later.');
    },

    setCandidateStatus() {
      this.moveCards('front', 'last');
      this.moveCards('front-1', 'front');
      this.moveCards('front-2', 'front-1');
    },

    setMinHeight() {
      const card = document.getElementsByClassName('card');
      let max = 550;
      if (card.length) {
        for (let i = 0; i < card.length; i += 1) {
          if (max < card[i].offsetHeight) {
            max = card[i].offsetHeight;
          }
        }
      }
      this.height = max + 50;
    },

    async startProgressBar(step) {
      if (step >= 120) {
        this.$store.dispatch('projects/LOAD', { force: true });
        return;
      }
      const percentWaited = (step / 120) * 100;
      this.$store.commit('projects/candidates/SET_PROGRESS', {
        projectId: this.projectId,
        progress: percentWaited,
      });
      await sleep(1000);
      await this.startProgressBar(step + 1);
    },

    onNextCandidate() {
      this.$emit('next-candidate');
    },

    onPrevCandidate() {
      this.$emit('prev-candidate');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.calibration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;

  img {
    width: auto;
    height: 33px;
  }
  span {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1px;
    color: $primary-dark;
  }
}
.candidate-carousel {
  &::v-deep .v-window__next,
  &::v-deep .v-window__prev {
    bottom: 0px;
    top: auto;
    background: none;
    cursor: pointer;
    margin: 0 16px;
  }

  &::v-deep .v-window__prev {
    right: 50%;
    left: auto;
  }
  &::v-deep .v-window__next {
    left: 50%;
    right: auto;
  }
}

.loading-candidate {
  z-index: 99;
}
.carousel-control__arrow {
  cursor: pointer;
  background-color: white;
  gap: 16px;
  &.prev {
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
    padding: 3px 13px 3px 2.5px;
  }
  &.next {
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;
    padding: 3px 2.5px 3px 13px;
  }
  &__text {
    font-size: 14px;
    font-weight: 500;
    color: $gray-dark;
    margin-top: 1px;
  }
}
</style>

<style scoped lang="scss">
.card-w {
  position: relative;
  padding-left: 40px;
  padding-right: 64px;
  width: 100%;
  background: rgb(230, 231, 235);
  background: linear-gradient(
    180deg,
    rgba(230, 231, 235, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}
.card-w-none-calibration {
  padding-right: 376px;
}

.pile {
  position: relative;
  max-width: 802px;
  /* max-height: 550px; */
  margin: 0 auto;
}

.pile .card {
  transition: transform 0.5s;
  z-index: 1;
  /* height: 100%; */
  display: flex;
  justify-content: stretch;
  max-width: none;
}

.pile .card.front-1 {
  transform: scale(0.95, 0.95) translate(0, -1.5rem);
}
.pile .card.front-2,
.pile .card.last,
.pile .card.behind {
  transform: scale(0.9, 0.9) translate(0, -3rem);
}
.pile .card.behind {
  display: none;
}

.pile .card.move-to-front {
  animation-name: move-to-front-animation;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

.pile .card.move-to-back-2 {
  animation-name: move-to-back-2-animation;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

.pile .card.move-to-back-3 {
  animation-name: move-to-back-3-animation;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

.hidden {
  visibility: hidden;
}
.calibration-toggle {
  position: absolute;
  top: 12px;
  right: 340px;
}
.calibration-toggle__text {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: #384955;
}
.loading-screen {
  z-index: 99;
  top: -2% !important;
  background-color: #eaebee;
  left: 0;
}

@keyframes move-to-front-animation {
  0% {
  }
  50% {
    transform: translate(0, 35rem);
    z-index: 1;
  }

  100% {
    transform: translate(0, 0) scale(1, 1);
    z-index: 2;
  }
}

@keyframes move-to-back-2-animation {
  0% {
  }
  50% {
    transform: translate(0, 35rem);
    z-index: 1;
  }
  51% {
    z-index: 0;
  }

  100% {
    transform: scale(0.95, 0.95) translate(0, -1.5rem);
    z-index: 0;
  }
}

@keyframes move-to-back-3-animation {
  0% {
  }
  50% {
    transform: translate(0, 35rem);
    z-index: 1;
  }
  51% {
    z-index: 0;
  }

  100% {
    transform: scale(0.9, 0.9) translate(0, -3rem);
    z-index: 0;
  }
}
.carousel-control {
  position: absolute;
  top: 2%;
  gap: 8px;
  width: 96%;
  padding-right: 336px;
}
.loader-box {
  padding-bottom: 120px;
}
.snackbar-text {
  top: 250px;
  left: -30px;
  &::v-deep .v-snack__content {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    padding: 0px 18px;
  }
}
.loader-img {
  bottom: 300px;
}
</style>
